import { LogOut, LayoutGrid, List } from 'lucide-react';
import { useState } from 'react';
import { RoomManagement } from './RoomManagement';
import { RoomOccupancyDashboard } from './RoomOccupancyDashboard';
import { useRoomManagement } from '../../hooks/useRoomManagementFirebase';

interface AdminDashboardProps {
  onLogout?: () => void;
}

export function AdminDashboard({ onLogout }: AdminDashboardProps) {
  const [viewMode, setViewMode] = useState<'occupancy' | 'management'>('occupancy');
  const { rooms } = useRoomManagement();

  const handleRoomClick = (room: any) => {
    alert(`Room ${room.room_number}\nType: ${room.type}\nStatus: ${room.status}${room.current_guest ? `\nGuest: ${room.current_guest.name}` : ''}`);
  };

  return (
    <div className="min-h-screen bg-luxury-gradient relative overflow-hidden">
      <div className="absolute inset-0 bg-luxury-pattern opacity-20"></div>
      
      {/* Header */}
      <header className="relative glass-luxury shadow-luxury-xl border-b border-gold-400/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <div>
              <h1 className="text-3xl font-bold text-gold-400">Hotel A.S.K Grand - Admin</h1>
              <p className="text-cream-200 text-lg">Complete hotel management system</p>
            </div>
            <div className="flex items-center gap-6">
              {/* View Mode Toggle */}
              <div className="flex items-center gap-2 bg-navy-800/50 rounded-lg p-1">
                <button
                  onClick={() => setViewMode('occupancy')}
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all ${
                    viewMode === 'occupancy'
                      ? 'bg-gold-gradient text-navy-900 font-bold'
                      : 'text-cream-300 hover:text-gold-400'
                  }`}
                >
                  <LayoutGrid className="w-4 h-4" />
                  Occupancy View
                </button>
                <button
                  onClick={() => setViewMode('management')}
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all ${
                    viewMode === 'management'
                      ? 'bg-gold-gradient text-navy-900 font-bold'
                      : 'text-cream-300 hover:text-gold-400'
                  }`}
                >
                  <List className="w-4 h-4" />
                  Management View
                </button>
              </div>

              <div className="text-right">
                <p className="text-sm text-cream-300">Welcome back,</p>
                <p className="font-bold text-gold-400 text-lg">Hotel Manager</p>
              </div>
              <div className="w-12 h-12 bg-gold-gradient rounded-2xl flex items-center justify-center shadow-gold">
                <span className="text-navy-900 font-bold text-lg">HM</span>
              </div>
              {onLogout && (
                <button
                  onClick={onLogout}
                  className="p-3 text-cream-300 hover:text-red-400 hover:bg-red-500/20 rounded-xl transition-colors border border-gold-400/20 hover:border-red-400/30"
                  title="Logout"
                >
                  <LogOut className="w-6 h-6" />
                </button>
              )}
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <div className="relative">
        {viewMode === 'occupancy' ? (
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <RoomOccupancyDashboard rooms={rooms} onRoomClick={handleRoomClick} />
          </div>
        ) : (
          <RoomManagement />
        )}
      </div>
    </div>
  );
}